var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclesBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 189.5,
    stroke: "url(#paint0_linear_5025_21538)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 144.5,
    stroke: "url(#paint1_linear_5025_21538)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 99.5,
    stroke: "url(#paint2_linear_5025_21538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5025_21538",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 380,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F151E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5025_21538",
    x1: 190,
    y1: 45,
    x2: 190,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F151E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5025_21538",
    x1: 190,
    y1: 90,
    x2: 190,
    y2: 290,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F151E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesBg);
export default __webpack_public_path__ + "static/media/circles-bg.ca511109d882ea36b869bcfa17a7eff7.svg";
export { ForwardRef as ReactComponent };